import React from 'react';

const DateDisplay = () => {
  const formatTurkishDate = () => {
    const now = new Date();
    const day = String(now?.getDate())?.padStart(2, '0');
    const month = String(now?.getMonth() + 1)?.padStart(2, '0');
    const year = now?.getFullYear();
    
    const turkishMonths = [
      'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
      'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'
    ];
    
    const monthName = turkishMonths?.[now?.getMonth()];
    
    return {
      numeric: `${day}/${month}/${year}`,
      readable: `${day} ${monthName} ${year}`
    };
  };

  const dateInfo = formatTurkishDate();

  return (
    <div className="text-center mb-6 md:mb-8 lg:mb-10">
      <div className="inline-flex flex-col items-center gap-2 md:gap-3">
        <div className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 rounded-xl md:rounded-2xl bg-primary/10 flex items-center justify-center">
          <svg 
            className="w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12" 
            fill="none" 
            stroke="var(--color-primary)" 
            strokeWidth="2" 
            viewBox="0 0 24 24"
          >
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
            <line x1="16" y1="2" x2="16" y2="6"/>
            <line x1="8" y1="2" x2="8" y2="6"/>
            <line x1="3" y1="10" x2="21" y2="10"/>
          </svg>
        </div>
        <div>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground font-medium mb-1">
            Bugün
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground">
            {dateInfo?.readable}
          </h2>
          <p className="text-xs md:text-sm text-muted-foreground mt-1">
            {dateInfo?.numeric}
          </p>
        </div>
      </div>
    </div>
  );
};

export default DateDisplay;